export enum ConsumptionAdjustmentMethod {
  historicalAverage = 'historicalAverage',
  manualCoefficient = 'manualCoefficient',
  historicalAverageIgnoreStarvation = 'historicalAverageIgnoreStarvation',
}
